import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-drop-down",
  "use": "icon-drop-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-drop-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 384l-512 0 256 320L768 384z\" p-id=\"2797\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol